import { useModel } from '@umijs/max';
import { useEffect, useState } from 'react';
import { HouseType } from '@/pages/House/interface';
import { queryBindHouse, querySetDefaultHouse } from '@/pages/House/service';
export default function useHouse() {
  const { wechatAccountInfo, handleQueryWechatAccountInfo } = useModel(
    'useGlobal',
    (model) => ({
      wechatAccountInfo: model.wechatAccountInfo,
      handleQueryWechatAccountInfo: model.handleQueryWechatAccountInfo,
    }),
  );

  const [houseList, setHouseList] = useState<HouseType[]>([]);

  const handleQueryBindHouse = async () => {
    const { code, data } = await queryBindHouse({
      openId: wechatAccountInfo?.openId,
      communityId: wechatAccountInfo?.communityId,
    });
    if (code === 200) {
      setHouseList(data || []);
    }
  };

  const handleBindHouse = async (id: string, roomId: string) => {
    const { code } = await querySetDefaultHouse({
      roomId: roomId,
      id: id,
      openId: wechatAccountInfo?.openId,
      communityId: wechatAccountInfo?.communityId,
    });
    if (code === 200) {
      handleQueryBindHouse();
      handleQueryWechatAccountInfo();
    }
  };

  useEffect(() => {
    if (wechatAccountInfo?.openId && wechatAccountInfo?.communityId) {
      handleQueryBindHouse();
    }
  }, [wechatAccountInfo]);

  return {
    houseList,
    handleQueryBindHouse,
    handleBindHouse,
  };
}
